export default __webpack_public_path__ + "static/media/28.ab6357c5.jpeg";